var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('universal-uploader',{staticClass:"text-truncate",attrs:{"clientAllowedFormats":['video']},on:{"uploadSuccess":_vm.uploadSuccess}},[_c('b-btn',{attrs:{"pill":"","variant":"secondary","size":"lg","block":""}},[_c('font-awesome-icon',{attrs:{"icon":"fa-duotone fa-cloud-arrow-up"}}),_vm._v(" Upload Video ")],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }